import { registerRenderWithType } from '../CommonRenderReact'

registerRenderWithType('language-configure')